import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { ICallTrackingProvider } from './typings'
import { getCallTrackingProviders } from './api'

const callTrackingProvidersAdaptor =
  createEntityAdapter<ICallTrackingProvider>()

export const initialState = callTrackingProvidersAdaptor.getInitialState<
  ICallTrackingProvider[]
>([])

export const callTrackingProviders = createSlice({
  name: 'callTrackingProviders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getCallTrackingProviders.fulfilled,
      (state, { payload }) => {
        callTrackingProvidersAdaptor.setAll(state, payload)
      },
    )
  },
})

export default callTrackingProviders.reducer

export const { selectAll: callTrackingProviderList } =
  callTrackingProvidersAdaptor.getSelectors(
    (state: StoreData) => state.callTrackingProviders,
  )
